import { qs } from 'utils/helpers.util';

import {
  EUserActionTypes,
  IUserState,
  TUserGetAddressesAPI,
  TUserAction,
  TUserDispatch,
  IAddress,
} from '../types/user.types';
import {
  TApiMiddlewareDispatch,
  EApiMiddlewareMethods,
} from 'config/redux/middlewares/api.middleware.types';
import { USER_ADDRESSES_API } from '../constants/api.constants';

import { setScreenToHide } from 'pages/Checkout/redux/actions/screen.actions';
import { validateCartEntries } from 'pages/Checkout/redux/actions/validateCart.actions';
import { IAppState } from 'config/redux/reducers';
import { userSetAddressesSuccess } from '@mafc/common';

export const userFetchAddressesSuccess = (addresses: IUserState['addresses']): TUserAction => ({
  type: EUserActionTypes.USER_FETCH_GET_ADDRESSES_SUCCESS,
  payload: { addresses },
});

export const setUserFetchLoading = (loading: IUserState['loading']): TUserAction => ({
  type: EUserActionTypes.USER_FETCH_SET_LOADING,
  payload: { loading },
});

export const fetchUserAddressesReturned = () => ({
  type: EUserActionTypes.USER_FETCH_SET_ADDRESS_LOADED,
  payload: { addressLoaded: true },
});

export const userFetchAddresses = () => (
  dispatch: TApiMiddlewareDispatch & TUserDispatch,
  getState: () => IAppState
) => {
  const {
    checkout: { stepsProgress },
    appConfig: { defaultAreaCode = '' },
  } = getState();
  dispatch(setUserFetchLoading(true));
  dispatch({
    type: EUserActionTypes.USER_FETCH_GET_ADDRESSES,
    payload: {
      enableProgress: false,
      onSuccess: ({ addresses }: TUserGetAddressesAPI) => {
        if (addresses && !addresses.length && stepsProgress.payment && stepsProgress.shipments) {
          // reload page to reset reducers when there is previous data and no address
          window.location.reload();
        }
        dispatch(userFetchAddressesSuccess(addresses));
        dispatch(userSetAddressesSuccess({ addresses, defaultAreaCode }));
      },
      onFinally: () => {
        dispatch(fetchUserAddressesReturned());
        dispatch(setUserFetchLoading(false));
      },
      url: USER_ADDRESSES_API,
    },
  });
};

export const setUserAddError = (
  errorMessage: IUserState['add']['error'],
  error: any
): TUserAction => {
  let errorNotification = errorMessage;
  if (error.response && error.response.data && error.response.data.errors) {
    const errorObj = error.response.data.errors[0];
    errorNotification = errorObj.message;
  }

  return {
    type: EUserActionTypes.USER_ADD_SET_ERROR,
    payload: { error: errorNotification },
  };
};

export const resetAddressError = () => ({
  type: EUserActionTypes.USER_ADD_SET_ERROR,
  payload: { error: null },
});

export const setUserAddLoading = (loading: IUserState['add']['loading']): TUserAction => ({
  type: EUserActionTypes.USER_ADD_SET_LOADING,
  payload: { loading },
});

export const userAddAddressSuccess = (address: IAddress): TUserAction => ({
  type: EUserActionTypes.USER_ADD_POST_ADDRESS_SUCCESS,
  payload: {
    addresses: [address],
  },
});

// TODO: match arg address with addres form fields later
export const userAddAddress = (address: { [K: string]: any }) => (
  dispatch: TApiMiddlewareDispatch & TUserDispatch
) => {
  dispatch(setUserAddLoading(true));

  const { fullName, phone, city, area, streetName, landmark, defaultAddress } = address;

  dispatch({
    type: EUserActionTypes.USER_ADD_POST_ADDRESS,
    payload: {
      data: qs({
        firstName: fullName,
        lastName: '',
        phone,
        town: area.code,
        'country.isocode': city.countryIso,
        'region.isocode': city.isocode,
        streetName,
        landmark,
        defaultAddress,
        shippingAddress: true /* always true as discussed with monami and peyman */,
      }),
      enableProgress: false,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: EApiMiddlewareMethods.POST,
      onSuccess: (apiResponse: IAddress) => {
        dispatch(userAddAddressSuccess(apiResponse));

        // These actions are required only for Checkout page!
        dispatch(setScreenToHide() as any);
        dispatch(validateCartEntries(apiResponse) as any);
      },
      onFailure: setUserAddError,
      onFinally: () => dispatch(setUserAddLoading(false)),
      url: USER_ADDRESSES_API,
    },
  });
};
